import { AsyncSelect, type IAsyncSelectProps } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { requestableCategoryRepository } from '@webapp/modules/expense/data-access/repositories/RequestableCategoryRepository'
import messages from './messages'

export type RequestablePrimaryCategorySelectValue = {
  id: number
  name: string
}

export interface IRequestablePrimaryCategorySelectProps extends IAsyncSelectProps<RequestablePrimaryCategorySelectValue> {}

export const RequestablePrimaryCategorySelect = ({
  ...props
}: IRequestablePrimaryCategorySelectProps) => {
  const intl = useProcurifyIntl()

  const loadOptions: IRequestablePrimaryCategorySelectProps['loadOptions'] = (
    inputValue,
    pagination,
    callback
  ) => {
    requestableCategoryRepository
      .listRequestableLocations({
        search: inputValue,
        page: pagination.page,
      })
      .then((res) => {
        callback({
          options: res.data.map((location) => ({
            id: location.id,
            name: location.name,
          })),
          pagination: {
            hasMore: res.pagination
              ? res.pagination.page < res.pagination.numPages
              : false,
            page: pagination.page + 1,
          },
        })
      })
      .catch(() => {
        callback({
          options: [],
          pagination: { hasMore: false, page: 1 },
        })
      })
  }

  return (
    <AsyncSelect<RequestablePrimaryCategorySelectValue>
      cacheOptions={true}
      loadOptions={loadOptions}
      placeholder={intl.formatMessage(messages.placeholderText)}
      getOptionLabel={(option) => option.name}
      getOptionValue={(option) => option.id.toString()}
      {...props}
    />
  )
}
